export const displayZoneWithRegulationsButtonSelector = ({displayZoneWithRegulationsButton}) => displayZoneWithRegulationsButton